import {
  EmailSchema,
  PagingSchema,
  PushSchema,
  SmsSchema,
  createDetailResponseSchema,
  createListResponseSchema,
  createListResponseSchemaDefault,
} from 'src/feature/bite/domain'
import z from 'zod'

export const ContactSchema = z.object({
  // employeeID: z.string().nullable(),
  firstname: z.string().nullable(),
  middlename: z.string().nullable(),
  lastname: z.string().nullable(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  titleName: z.string().nullable(),
  titleID: z.string().nullable(),
})

export const SubscriptionSchema = z.object({
  typeName: z.string(),
  typeID: z.number(),
  price: z.number(),
  statusID: z.number(),
  customerPackage: z.string(),
  activationDate: z.string(),
  expiryDate: z.string(),
  lastInvoiceDate: z.string(),
  cardOnFile: z.boolean(),
})

export const InvoiceSchema = z.object({
  invoiceIssuerID: z.string().nullable(),
  invoiceNo: z.string().nullable(),
  date: z.string(),
  amount: z.number(),
  discountedAmount: z.number(),
  invoiceIssuerName: z.string().nullable(),
  paymentType: z.number(),
})

export const TransactionSchema = z.object({
  orderId: z.string().nullable(),
  date: z.string().nullable(),
  posNo: z.string().nullable(),
  type: z.any().nullable(),
  totalAmount: z.number().nullable(),
  paidAmount: z.number().nullable(),
  discountAmount: z.number().nullable(),
  channel: z.any().nullable(),
  storeNo: z.string().nullable(),
  transactionId: z.string().nullable(),
  memberId: z.string().nullable().optional(),
  memberName: z.string().nullable().optional(),
})

export const ActivitySchema = z.object({
  orderId: z.string().nullable(),
  date: z.string().nullable(),
  posNo: z.string().nullable(),
  type: z.any().nullable(),
  totalAmount: z.number().nullable(),
  paidAmount: z.number().nullable(),
  discountAmount: z.number().nullable(),
  channel: z.any().nullable(),
  storeNo: z.string().nullable(),
  transactionId: z.string().nullable(),
  memberId: z.string().nullable().optional(),
  memberName: z.string().nullable().optional(),
})

export const TerminalSchema = z.object({
  devicOS: z.string().nullable(),
  deviceModel: z.string(),
  terminalId: z.string(),
  typeID: z.any(),
  statusID: z.any(),
  loyaltyStatusID: z.any(),
  lastTrxDate: z.string(),
})

export const OptionalSchema = z.object({
  webSite: z.string().nullable().optional(),
  seasonPeriod: z.boolean(),
  seasonStartDate: z.string(),
  seasonEndDate: z.string(),
  closingTime: z.string().nullable(),
  openingTime: z.string().nullable(),
  latitude: z.any().nullable(),
  longitude: z.any().nullable(),
  workingDays: z.array(z.number()),
})

export const CommissionSchema = z.object({
  id: z.string(),
  paymentTypeName: z.string(),
  storeName: z.string(),
  chainName: z.string(),
})

export const CommissionDetail = z.object({
  commission: z.object({
    id: z.string(),
    paymentTypeName: z.string(),
    storeName: z.string(),
    chainName: z.string(),
  }),
})

export const CommissionListSchema = z.object({
  id: z.string(),
  min: z.number(),
  max: z.number(),
  commissionID: z.string(),
  commission: z.number(),
  commissionFee: z.number(),
})

export const UserSchema = z.object({
  id: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().nullable(),
  roleId: z.string(),
  createdOn: z.string(),
  lastLogin: z.string().nullable(),
  status: z.number(),
})

export const UserDetail = z.object({
  user: z.object({
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string().nullable(),
    roleId: z.string().nullable(),
    roleName: z.string().nullable(),
    lastLogin: z.string().nullable(),
    status: z.number().optional(),
  }),
})

export const StoreSchema = z.object({
  id: z.string(),
  no: z.string(),
  // groupID: z.string(),
  // chainID: z.string(),
  extraID: z.string().nullable(),
  rS2MerchantID: z.string().nullable().optional(),
  name: z.string().nullable(),
  mccCode: z.string().nullable().optional(),
  slipName: z.string().nullable().optional(),
  slipSlogan: z.string().nullable().optional(),
  aptBuildingNo: z.string().nullable().optional(),
  status: z.number().nullable(),
  addressLine: z.string().nullable(),
  businessAddressLine: z.string().nullable().optional(),
  regionName: z.string().nullable(),
  regionId: z.string().nullable(),
  cityName: z.string().nullable(),
  cityID: z.string().nullable(),
  countryName: z.string().nullable(),
  countryID: z.string().nullable(),
  zipCode: z.string().nullable().optional(),
  phone: z.string().nullable(),
  isoName: z.string().nullable().optional(),
  isoid: z.string().nullable().optional(),
  invoiceIssuer: z.number().nullable().optional(),
  longitude: z.number().nullable(),
  latitude: z.number().nullable(),
  // beyond: z.string(),
  agreementDate: z.string().nullable().optional(),
  // Tab Data
  // Contact: z.object({ dataList: ContactSchema.array(), paging: PagingSchema }).optional(),
  Contact: ContactSchema.optional(),
  Subscription: z.object({dataList: SubscriptionSchema.array(), paging: PagingSchema}).optional(),
  Invoice: z.object({dataList: InvoiceSchema.array(), paging: PagingSchema}).optional(),
  Transaction: z.object({dataList: TransactionSchema.array(), paging: PagingSchema}).optional(),
  Activities: z
    .object({dataList: ActivitySchema.array(), paging: PagingSchema})
    .optional()
    .nullable(),
  Terminal: z.object({dataList: TerminalSchema.array(), paging: PagingSchema}).optional(),
  Optional: OptionalSchema.optional(),
  User: z.object({dataList: UserSchema.array(), paging: PagingSchema}).optional(),
  UserDetail: UserDetail.optional(),
  Commission: z.object({dataList: CommissionSchema.array(), paging: PagingSchema}).optional(),
  CommissionDetail: CommissionDetail.optional(),
  // Engagements
  SmsEngagement: z
    .object({dataList: SmsSchema.array(), paging: PagingSchema.optional()})
    .optional(),
  PushEngagement: z
    .object({dataList: PushSchema.array(), paging: PagingSchema.optional()})
    .optional(),
  EmailEngagement: z
    .object({dataList: EmailSchema.array(), paging: PagingSchema.optional()})
    .optional(),
})

export const MerchantSchema = z.object({
  id: z.string().nullable().optional(),
  status: z.number().nullable().optional(),
  address: z.string().nullable().optional(),
  addressLine: z.string().nullable().optional(),
  categoryIDs: z.array(z.string()).nullable().optional(),
  countryID: z.string().nullable().optional(),
  cityID: z.string().nullable().optional(),
  agreementDate: z.string().nullable().optional(),
  subCategoryIDs: z.array(z.string()).nullable().optional(),
  mccCode: z.string().nullable().optional(),
  merchantID: z.string().nullable().optional(),
  slipSlogan: z.string().nullable().optional(),
  slipName: z.string().nullable().optional(),
  webSite: z.string().nullable().optional(),
  zipCode: z.string().nullable().optional(),
  contactEmail: z.string().nullable().optional(),
  financialCurrency: z.number().nullable().optional(),
  financialPayoutDate: z.number().nullable().optional(),
  financialPayoutMethod: z.number().nullable().optional(),
  contractDurationPeriod: z.number().nullable().optional(),
  contactDuration: z.number().nullable().optional(),
  termsAndConditionsEnabled: z.boolean().nullable().optional(),
  financialPaymentFrequency: z.number().nullable().optional(),
  contactPhone: z.string().nullable().optional(),
  contactName: z.string().nullable().optional(),
  contactSurname: z.string().nullable().optional(),
  contactTitle: z.string().nullable().optional(),
  instagram: z.string().nullable().optional(),
  linkedIn: z.string().nullable().optional(),
  twitter: z.string().nullable().optional(),
  facebook: z.string().nullable().optional(),
  financialOfficialName: z.string().nullable().optional(),
  financialBankName: z.string().nullable().optional(),
  financialTaxOffice: z.string().nullable().optional(),
  financialInvoiceAddress: z.string().nullable().optional(),
  financialIBAN: z.string().nullable().optional(),
  financialTaxNumber: z.string().nullable().optional(),
  contractDate: z.string().nullable().optional(),
  contractURL: z.string().nullable().optional(),
  onBoardingDate: z.string().nullable().optional(),
  officialName: z.string().nullable().optional(),
  additionalInformations: z.string().nullable().optional(),
  currencyID: z.string().nullable().optional(),
  imagesData: z
    .array(
      z.object({
        id: z.string().nullable().optional(),
        imageUrl: z.string().nullable().optional(),
        imageFullUrl: z.string().nullable().optional(),
        imageTypeID: z.string().nullable().optional(),
        imageType: z.number().nullable().optional(),
        imageTypeName: z.string().nullable().optional(),
        order: z.number().nullable().optional(),
        createdAt: z.string().nullable().optional(),
      })
    )
    .nullable()
    .optional(),
  infoContentData: z
    .array(
      z.object({
        id: z.string().nullable().optional(),
        name: z.string().nullable().optional(),
        contentURL: z.string().nullable().optional(),
        data: z.string().nullable().optional(),
      })
    )
    .nullable()
    .optional(),
})

export const Responses = {
  // Contact: createListResponseSchema(ContactSchema.array()),
  Contact: createDetailResponseSchema(ContactSchema),
  Subscription: createListResponseSchema(SubscriptionSchema.array()),
  Invoice: createListResponseSchema(InvoiceSchema.array()),
  Transaction: createListResponseSchema(TransactionSchema.array()),
  Activities: createListResponseSchema(ActivitySchema.array()),
  Terminal: createListResponseSchema(TerminalSchema.array()),
  Optional: createDetailResponseSchema(OptionalSchema),
  User: createListResponseSchema(UserSchema.array()),
  UserDetail: createDetailResponseSchema(UserDetail),
  Commission: createListResponseSchema(CommissionSchema.array()),
  CommissionDetail: createDetailResponseSchema(CommissionDetail),
  SmsEngagement: createListResponseSchema(SmsSchema.array()),
  PushEngagement: createListResponseSchema(PushSchema.array()),
  EmailEngagement: createListResponseSchema(EmailSchema.array()),
}

export const StoreSchemaResponse = createDetailResponseSchema(
  z.object({
    store: StoreSchema.nullable(),
  })
)

export const MerchantSchemaResponse = createDetailResponseSchema(MerchantSchema.nullable())

export const RecentTransactionsSchemaResponse = createListResponseSchema(TransactionSchema.array())

export type RecentTransactions = z.infer<typeof RecentTransactionsSchemaResponse.shape.response>

export const StoreContactTitleListSchema = z.object({
  id: z.string(),
  name: z.string(),
})

export type StoreContactTitle = z.infer<typeof StoreContactTitleListSchema>

export const StoreContactTitleListSchemaResponse = createListResponseSchemaDefault(
  z.object({storeContactTitleList: StoreContactTitleListSchema.array()})
)

export type StoreContactTitleList = z.infer<
  typeof StoreContactTitleListSchemaResponse.shape.response
>

export const UserDetailSchemaResponse = createDetailResponseSchema(UserDetail)

export type UserDetail = z.infer<typeof UserDetail>

export const ComissionListSchemaResponse = createListResponseSchema(CommissionListSchema.array())

export const CommissionDetailSchemaResponse = createDetailResponseSchema(CommissionDetail)

export type CommissionDetail = z.infer<typeof CommissionDetailSchemaResponse.shape.response>

export type ComissionList = z.infer<typeof ComissionListSchemaResponse.shape.response>

export type Store = z.infer<typeof StoreSchema>
export type StoreResponse = z.infer<typeof StoreSchemaResponse>

export type Merchant = z.infer<typeof MerchantSchema>
export type MerchantResponse = z.infer<typeof MerchantSchemaResponse>
